import { render, staticRenderFns } from "./TargetEventItem.vue?vue&type=template&id=16d4bbda&scoped=true&"
import script from "./TargetEventItem.vue?vue&type=script&lang=js&"
export * from "./TargetEventItem.vue?vue&type=script&lang=js&"
import style0 from "./TargetEventItem.vue?vue&type=style&index=0&id=16d4bbda&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d4bbda",
  null
  
)

export default component.exports